import get from 'lodash/get'

export const getShowVehicleModal = (state) =>
  get(state, 'modal.showVehicleModal')

  export const getShowSellCarModal = (state) =>
  get(state, 'modal.showSellCarModal')
